"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.iconForType = iconForType;
exports.IconType = exports.workpapersApp = exports.vatApp = exports.ultraTaxApp = exports.trialBalanceApp = exports.trialBalanceEstudioContableApp = exports.taxApp = exports.taxAmnestyApp = exports.secretarialApp = exports.noApp = exports.investmentAccountsApp = exports.grossIncomeTaxApp = exports.fixedAssetsApp = exports.companyFormationsApp = exports.checkpointEngageApp = exports.advisoryApp = exports.activityStatementsApp = exports.accountingApp = exports.exit = exports.folderGlobe = exports.folderGlobeShare = exports.rotate90 = exports.help = exports.externalLink = exports.dropdownArrow = exports.mailOutline = exports.starBorder = exports.panTool = exports.danger = exports.success = exports.users = exports.user = exports.star = exports.share = exports.print = exports.filePowerPoint = exports.plusPlain = exports.newIcon = exports.minusPlain = exports.lock = exports.info = exports.hamburgerMenu = exports.folder = exports.folderFilled = exports.file = exports.fileWord = exports.filePdf = exports.fileImage = exports.fileFilled = exports.fileExcel = exports.expand = exports.dot = exports.collapse = exports.closeXThin = exports.closeX = exports.close = exports.checkpointEngage = exports.checkmarkFilledCircle = exports.checkmark = exports.checkbox = exports.checkboxFilled = exports.calendar = exports.buildings = exports.briefcase = exports.add = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@blue/element");

function _templateObject64() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" xml:space=\"preserve\">\n\t<path fill=\"#397C2B\" d=\"M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm8.607 9.557L9.048 4H7.38L5.808 9.557 4.512 4H3l2.1 7.992h1.404L8.22 5.644l1.692 6.348h1.404L13.404 4h-1.512l-1.285 5.557z\"/>\n</svg>\n"]);

  _templateObject64 = function _templateObject64() {
    return data;
  };

  return data;
}

function _templateObject63() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 79.86 79.86\">\n\t<path d=\"M68.52 0H11.34A11.34 11.34 0 000 11.34v57.18a11.34 11.34 0 0011.34 11.34h57.18a11.34 11.34 0 0011.34-11.34V11.34A11.34 11.34 0 0068.52 0zM44.24 60.34h-8.71L21.09 19.93h8.84l10.23 29.91 9.9-29.91h8.65z\" fill=\"#0072a8\" data-name=\"Layer 1\"/>\n</svg>\n"]);

  _templateObject63 = function _templateObject63() {
    return data;
  };

  return data;
}

function _templateObject62() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" version=\"1.1\" height=\"100%\" width=\"100%\" xml:space=\"preserve\">\n\t<path fill=\"#004683\" fill-opacity=\".829\" opacity=\"1\" d=\"M.143 0H48v48H.143z\"/>\n\t<text transform=\"scale(1.04576 .95624)\" y=\"45.535\" x=\"15.451\" style=\"line-height:0%\" xml:space=\"preserve\" font-style=\"normal\" font-weight=\"400\" font-family=\"sans-serif\" letter-spacing=\"0\" word-spacing=\"0\" fill=\"#fff\" fill-opacity=\"1\" stroke=\"none\" stroke-width=\"1\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\" stroke-opacity=\"1\">\n\t\t<tspan style=\"line-height:1.25;-inkscape-font-specification:Arial\" y=\"45.535\" x=\"15.451\" font-style=\"normal\" font-variant=\"normal\" font-weight=\"400\" font-stretch=\"normal\" font-size=\"44.003\" font-family=\"Arial\">S</tspan>\n\t</text>\n\t<path fill=\"#fff\" d=\"M29.214 5.143h5.143v42.714h-5.143z\"/>\n\t<text y=\"27.143\" x=\"6.143\" style=\"line-height:0%;-inkscape-font-specification:'Times New Roman, '\" xml:space=\"preserve\" font-style=\"normal\" font-variant=\"normal\" font-weight=\"400\" font-stretch=\"normal\" font-family=\"Times New Roman\" letter-spacing=\"0\" word-spacing=\"0\" fill=\"#000\" fill-opacity=\"1\" stroke=\"none\" stroke-width=\"1\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\" stroke-opacity=\"1\"/>\n\t<text y=\"20.714\" x=\"9.714\" style=\"line-height:0%\" xml:space=\"preserve\" font-style=\"normal\" font-weight=\"400\" font-family=\"sans-serif\" letter-spacing=\"0\" word-spacing=\"0\" fill=\"#000\" fill-opacity=\"1\" stroke=\"none\" stroke-width=\"1\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\" stroke-opacity=\"1\"/>\n\t<path opacity=\".942\" fill=\"#00f\" fill-opacity=\".941\" d=\"M84-20.857h.286V-20H84z\"/>\n</svg>\n"]);

  _templateObject62 = function _templateObject62() {
    return data;
  };

  return data;
}

function _templateObject61() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" xml:space=\"preserve\">\n\t<path fill=\"#397C2B\" d=\"M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm3.168 5.52H7.4V4.008H1.184V5.52h2.232V12h1.752V5.52zm3.276-1.512V12h3.708c.392 0 .746-.055 1.062-.162s.586-.258.81-.449c.225-.193.396-.423.517-.69.12-.269.181-.566.181-.894 0-.545-.154-.971-.463-1.279-.308-.308-.71-.513-1.206-.617.48-.168.835-.422 1.062-.762.229-.34.343-.734.343-1.182 0-.608-.202-1.086-.606-1.434-.404-.348-.978-.522-1.722-.522H8.444zm3.216 3.3h-1.488V5.376h1.452c.376 0 .653.08.834.24.181.16.271.38.271.66 0 .272-.084.512-.252.72s-.441.312-.817.312zm.252 3.324h-1.74V8.676h1.656c.376 0 .664.084.863.252.201.168.301.4.301.696 0 .304-.088.548-.264.731-.176.185-.449.277-.816.277z\"/>\n</svg>\n"]);

  _templateObject61 = function _templateObject61() {
    return data;
  };

  return data;
}

function _templateObject60() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" viewBox=\"0 0 100 100\" xml:space=\"preserve\">\n\t<path fill=\"#397C2B\" d=\"M0 0v100h100V0H0zm13.64 25.999h32.256v7.776H22.64v11.664h21.744v7.775H22.64v12.96h23.256v7.776H13.64V25.999zm38.016 23.976c0-3.839.562-7.295 1.691-10.367 1.127-3.071 2.735-5.676 4.823-7.812 2.088-2.135 4.597-3.78 7.524-4.932 2.927-1.152 6.191-1.728 9.791-1.728 3.023 0 5.699.277 8.027.828 2.328.552 4.213 1.164 5.652 1.836l-1.367 7.128c-1.488-.575-3.168-1.055-5.041-1.44-1.871-.383-3.648-.575-5.328-.575-5.424 0-9.574 1.429-12.455 4.284s-4.32 7.117-4.32 12.779c0 5.666 1.439 9.926 4.32 12.78 2.881 2.856 7.031 4.284 12.455 4.284 1.68 0 3.457-.191 5.328-.576 1.873-.384 3.553-.863 5.041-1.439l1.367 7.129c-1.439.673-3.324 1.283-5.652 1.836-2.328.551-5.004.828-8.027.828-3.6 0-6.864-.576-9.791-1.729-2.93-1.151-5.438-2.795-7.524-4.932-2.088-2.136-3.696-4.739-4.823-7.812-1.126-3.074-1.691-6.529-1.691-10.37z\"/>\n</svg>\n"]);

  _templateObject60 = function _templateObject60() {
    return data;
  };

  return data;
}

function _templateObject59() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" xml:space=\"preserve\">\n\t<path fill=\"#005885\" d=\"M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6.876 5.52h2.231V4.008H4.892V5.52h2.232V12h1.752V5.52z\"/>\n</svg>\n"]);

  _templateObject59 = function _templateObject59() {
    return data;
  };

  return data;
}

function _templateObject58() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" viewBox=\"0 0 100 100\" xml:space=\"preserve\">\n\t<path fill=\"#FF8000\" d=\"M0 0v100h100.001V0H0zm49.644 74.838c-5.688 0-12.169-1.441-17.138-3.529l1.944-7.271c4.824 2.018 10.369 3.384 15.121 3.384 5.761 0 9.434-1.655 9.434-6.119 0-4.393-2.81-5.762-10.514-7.418-10.656-2.231-16.129-6.048-16.129-14.473 0-10.656 7.2-14.258 17.857-14.258 6.408 0 11.449 1.152 16.131 3.312l-1.656 7.201c-4.104-1.801-9.289-3.168-14.33-3.168-5.905 0-9.001 1.367-9.001 5.977 0 4.031 2.808 5.184 10.657 7.128 10.297 2.521 16.058 5.473 16.058 14.689-.001 9.145-6.842 14.545-18.434 14.545z\"/>\n</svg>\n"]);

  _templateObject58 = function _templateObject58() {
    return data;
  };

  return data;
}

function _templateObject57() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" xml:space=\"preserve\">\n\t<path fill=\"#FF8000\" d=\"M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm9.066 9.636c0-.392-.059-.722-.174-.989a1.788 1.788 0 00-.511-.679 2.928 2.928 0 00-.827-.462 9.548 9.548 0 00-1.14-.342c-.32-.072-.586-.14-.798-.204a2.584 2.584 0 01-.51-.204.711.711 0 01-.276-.252.732.732 0 01-.084-.372c0-.336.108-.56.324-.672.216-.112.544-.168.984-.168.424 0 .846.05 1.266.15s.802.226 1.146.378l.312-1.392a6.396 6.396 0 00-1.266-.42 6.922 6.922 0 00-1.482-.144c-.448 0-.856.04-1.224.12-.368.08-.688.214-.96.402-.272.188-.482.44-.63.756s-.222.71-.222 1.182c0 .376.06.7.18.972s.296.504.528.696c.232.192.516.35.852.474a7.92 7.92 0 001.164.318c.296.063.546.124.75.18.204.056.37.124.498.204s.218.174.27.282a.89.89 0 01.078.39c0 .328-.129.555-.385.678-.256.125-.604.187-1.043.187-.384 0-.794-.052-1.23-.156a9.357 9.357 0 01-1.266-.396l-.372 1.404a8.01 8.01 0 001.404.426 7.22 7.22 0 001.476.162c1.016 0 1.797-.219 2.346-.654.548-.436.822-1.055.822-1.855z\"/>\n</svg>\n"]);

  _templateObject57 = function _templateObject57() {
    return data;
  };

  return data;
}

function _templateObject56() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" xml:space=\"preserve\">\n\t<path opacity=\".737\" fill=\"#B2B2B8\" stroke=\"#B2B2B8\" d=\"M2.5.5h11a2 2 0 012 2v11a2 2 0 01-2 2h-11a2 2 0 01-2-2v-11a2 2 0 012-2z\"/>\n\t<path fill=\"none\" stroke=\"#EBF7FA\" stroke-linecap=\"square\" d=\"M15.5.5l-15 15\"/>\n</svg>\n"]);

  _templateObject56 = function _templateObject56() {
    return data;
  };

  return data;
}

function _templateObject55() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n<svg width=\"100%\" height=\"100%\" viewBox=\"0 0 100 100\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">\n\t<g fill=\"#FF8000\" fill-rule=\"nonzero\" stroke=\"none\" stroke-width=\"1\">\n\t\t<path d=\"M37.749 35.09C36.248 33.696 34.232 33 31.702 33H20v16h11.702c2.53 0 4.546-.715 6.047-2.145 1.5-1.43 2.251-3.418 2.251-5.965 0-2.472-.75-4.407-2.251-5.8z\"/>\n\t\t<path d=\"M0 12v76c0 6.627 5.373 12 12 12h76c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12H12C5.373 0 0 5.373 0 12zm40.09 62.107l-11.523-18.17h-8.979v18.17h-9.05V25.892h22.094c4.996 0 8.902 1.367 11.719 4.101s4.225 6.386 4.225 10.958c0 3.27-.902 6.163-2.705 8.673-1.803 2.513-4.26 4.306-7.37 5.378l12.938 19.105H40.09zm49.373-40.402H66.344v13.326h21.599v7.813H66.344v19.264h-9.049V25.892h32.168v7.813z\"/>\n\t</g>\n</svg>\n"]);

  _templateObject55 = function _templateObject55() {
    return data;
  };

  return data;
}

function _templateObject54() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n<svg width=\"16\" height=\"16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">\n\t<g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n\t\t<rect fill=\"#FF8000\" x=\"0\" y=\"0\" width=\"16\" height=\"16\" rx=\"2\"/>\n\t\t<path d=\"M4.137 12.59V4H3v8.59h1.137zm5.12 0c.547 0 1.008-.048 1.385-.144.377-.095.69-.237.94-.425.25-.187.46-.454.63-.8.17-.345.256-.719.256-1.121 0-.5-.14-.934-.42-1.301-.279-.367-.678-.627-1.198-.78.403-.199.704-.46.903-.785.199-.324.299-.67.299-1.037 0-.394-.113-.772-.337-1.134a2.03 2.03 0 00-.932-.802C10.387 4.087 9.86 4 9.203 4H5.982v8.59h3.276zm-.282-4.98H7.118V5.013h1.717c.617 0 1.052.04 1.306.12.254.08.45.228.586.445.137.217.205.468.205.753 0 .3-.073.55-.22.75-.146.2-.364.342-.653.428-.218.066-.58.1-1.084.1zm.282 3.966H7.118V8.623h1.986c.547 0 .966.048 1.257.144.291.095.519.261.683.498.164.236.246.514.246.835 0 .273-.057.514-.17.723a1.244 1.244 0 01-.434.478c-.175.11-.394.187-.656.234-.148.027-.406.041-.773.041z\" fill=\"#FFF\" fill-rule=\"nonzero\"/>\n\t</g>\n</svg>\n"]);

  _templateObject54 = function _templateObject54() {
    return data;
  };

  return data;
}

function _templateObject53() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" xml:space=\"preserve\">\n\t<path fill=\"#621F95\" d=\"M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm-.192 4.008V12H3.56V8.928h3.456V7.416H3.56V5.52h3.696V4.008H1.808zm8.256 0L7.16 12h1.775l.576-1.764h3.049L13.137 12h1.775l-2.904-7.992h-1.944zm-.072 4.763l1.044-3.191 1.044 3.191H9.992z\"/>\n</svg>\n"]);

  _templateObject53 = function _templateObject53() {
    return data;
  };

  return data;
}

function _templateObject52() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" viewBox=\"0 0 100 100\" xml:space=\"preserve\">\n\t<path fill=\"#FF8000\" d=\"M-.001 0v100h100.002V0H-.001zm37.837 67.061c3.383 0 7.416-.865 10.367-2.018l1.369 7.129c-2.881 1.368-7.705 2.664-13.682 2.664-14.4 0-23.834-9.434-23.834-24.842 0-15.409 9.434-24.842 23.834-24.842 5.977 0 10.801 1.296 13.682 2.664l-1.369 7.129c-2.951-1.152-6.984-2.017-10.367-2.017-10.802 0-16.778 5.833-16.778 17.065 0 11.232 5.976 17.068 16.778 17.068zm50.975-33.268H65.842v13.249h21.457v7.849H65.842v19.082H56.84V26.016h31.971v7.777z\"/>\n</svg>\n"]);

  _templateObject52 = function _templateObject52() {
    return data;
  };

  return data;
}

function _templateObject51() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" xml:space=\"preserve\">\n\t<path fill=\"#A00000\" d=\"M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm-.558 8.004c0 .648.096 1.23.288 1.746s.462.95.81 1.302c.348.353.768.622 1.26.81a4.52 4.52 0 001.626.283c.528 0 .99-.049 1.386-.145s.71-.204.942-.324l-.264-1.38a4.387 4.387 0 01-.81.24 4.358 4.358 0 01-.87.096c-.856 0-1.506-.214-1.95-.642-.444-.428-.666-1.09-.666-1.986 0-.896.222-1.558.666-1.986.444-.428 1.094-.642 1.95-.642.272 0 .562.032.87.096.308.064.578.144.81.24l.264-1.38a4.311 4.311 0 00-.942-.324 5.926 5.926 0 00-1.386-.144 4.52 4.52 0 00-1.626.282c-.492.188-.912.458-1.26.81s-.618.786-.81 1.302c-.192.516-.288 1.098-.288 1.746zm7.44-3.996V12h5.496v-1.512h-3.744V8.664h3.505V7.152h-3.505V5.52h3.744V4.008H8.882z\"/>\n</svg>\n"]);

  _templateObject51 = function _templateObject51() {
    return data;
  };

  return data;
}

function _templateObject50() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" xml:space=\"preserve\">\n\t<path fill=\"#0099CA\" d=\"M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm5.028 4.008L4.124 12H5.9l.576-1.764h3.047L10.1 12h1.776L8.973 4.008H7.028zm-.072 4.763L8 5.58l1.044 3.191H6.956z\"/>\n</svg>\n"]);

  _templateObject50 = function _templateObject50() {
    return data;
  };

  return data;
}

function _templateObject49() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0\" y=\"0\" viewBox=\"0 0 80 80\" xml:space=\"preserve\">\n\t<path fill=\"#0072a8\" d=\"M18.5 44.4h11l-5.6-14.9z\"/>\n\t<path fill=\"#0072a8\" d=\"M68.6.1H11.4C5.1.1.1 5.2.1 11.5v57.2c0 6.2 5 11.3 11.3 11.3h57.2c6.3 0 11.3-5.1 11.3-11.3V11.5c0-6.3-5-11.4-11.3-11.4zm-33 60.3l-3.5-9.1H16l-3.3 9.1H4l15.7-40.3h8.6l16.1 40.3h-8.8zm38.6-5.3c-1.3 2-3.1 3.5-5.4 4.5-2.3 1-5.3 1.5-8.8 1.5-5.1 0-9-1.2-11.7-3.5-2.7-2.4-4.4-5.8-4.9-10.3l7.9-.8c.5 2.7 1.4 4.6 2.9 5.8 1.5 1.2 3.4 1.9 5.9 1.9 2.6 0 4.6-.6 5.9-1.7 1.3-1.1 2-2.4 2-3.9 0-1-.3-1.8-.8-2.4-.6-.7-1.5-1.2-2.9-1.7-1-.3-3.1-.9-6.5-1.8-4.4-1.1-7.4-2.4-9.2-4-2.5-2.2-3.7-4.9-3.7-8.1 0-2 .6-4 1.7-5.8 1.2-1.8 2.8-3.1 5-4.1 2.2-.9 4.8-1.4 7.9-1.4 5.1 0 8.9 1.1 11.4 3.3 2.6 2.2 3.9 5.2 4 8.9l-8.1.5c-.3-2.1-1.1-3.6-2.2-4.5-1.1-.9-2.9-1.4-5.1-1.4-2.4 0-4.2.5-5.5 1.5-.9.6-1.3 1.5-1.3 2.5s.4 1.8 1.2 2.4c1 .9 3.5 1.8 7.5 2.7 4 .9 6.9 1.9 8.8 2.9 1.9 1 3.4 2.4 4.4 4.1 1.1 1.7 1.6 3.9 1.6 6.4-.1 2.3-.8 4.5-2 6.5z\"/>\n</svg>\n"]);

  _templateObject49 = function _templateObject49() {
    return data;
  };

  return data;
}

function _templateObject48() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" viewBox=\"0 0 16 16\" xml:space=\"preserve\">\n\t<path fill=\"#397C2B\" d=\"M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm5.028 4.008L4.124 12H5.9l.576-1.764h3.047L10.1 12h1.776L8.973 4.008H7.028zm-.072 4.763L8 5.58l1.044 3.191H6.956z\"/>\n</svg>\n"]);

  _templateObject48 = function _templateObject48() {
    return data;
  };

  return data;
}

function _templateObject47() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 136.374 164.344\">\n\t<path d=\"M75.858 18.489H15.342v127.366h60.516V119.15H91.2v45.195H0V0h91.2v45.195H75.858V18.489zm60.516 63.683l-30.684 40.059v-21.57H45.174V63.683h60.516v-21.57l30.684 40.059z\"/>\n</svg>\n"]);

  _templateObject47 = function _templateObject47() {
    return data;
  };

  return data;
}

function _templateObject46() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1\" viewBox=\"0 0 600 550\">\n\t\t<path d=\"M0 229.3c0 115.2.3 230.4.7 256l.6 46.7H234c128 0 255.7-.3 283.8-.7l51.2-.6V380c0-82.9-.3-185.2-.7-227.3l-.6-76.7H309.5l-28-28-28-28H0v209.3zm258-123.8l28.5 28.5h111.7c61.5 0 111.9.3 111.9.7.1.5.5 77 .8 170.1l.6 169.2H337c-96 0-197.7.3-226.1.7l-51.7.6-.6-8.4c-.3-4.6-.7-94-.9-198.6L57.5 78l64.5-.3c35.5-.1 74.2-.3 86-.5l21.5-.2 28.5 28.5z\"/>\n\t\t<path d=\"M272.2 180c-40.6 4.1-76.7 28-97 64.1-4.9 8.6-9.9 22.5-12.1 33.6-2.6 12.8-2.9 36-.5 48.4 5.1 26.8 17.1 48.9 37 67.9 14.8 14.2 32.6 24.4 51.3 29.4 43.9 11.8 90-.3 121.6-31.9 25.5-25.4 37.7-56.7 36.1-92.5-.9-20.3-4.8-35.5-13.4-52.4-17-33.3-48.8-57.1-86-64.5-12-2.4-26.1-3.2-37-2.1zm31 17.5c8.6 1.5 22.5 5.8 25.3 7.9 1.7 1.2 1.7 1.4-.3 3.4-2.9 2.9-6.1 2.8-10.8-.4-3.1-2.1-4.6-2.5-8.1-2.1-6.3.7-15 5.4-21.5 11.8-4.6 4.5-5.8 6.3-5.8 8.8 0 3.6.1 3.6 5.8 1.6 8.9-3.1 11.1 3.3 3.9 11.2-2.7 3-5.2 2.9-13-.7-7.1-3.4-11.9-3.4-11 0 .6 2.4-10.6 8-16.5 8.3-2.3 0-4.2.5-4.2 1s1.4 2.5 3 4.4c1.7 1.8 3 3.8 3 4.3s-1.8 1.4-4.1 2c-7.6 2.1-5.6 7 2.8 7 5.9 0 10.2-2.3 10.9-6 .4-1.9 1.6-3.2 3.4-4 5.2-2.1 8.4-.5 16.7 8.6 8.6 9.6 11.4 11.4 17.3 11.4 4.5 0 4.4.1 3-3.6-3.3-8.5 10.1-19.2 17-13.6l2.5 2-4.7 4.4c-4.8 4.3-6.2 7.8-3.3 7.8 4.8 0-1.5 5.1-13.5 10.8-4.7 2.3-9.2 4.6-10 5.3-2.5 1.8-11.6-2.4-20-9.1-14.5-11.8-20-13.1-32.3-7.9-12.9 5.4-20.2 15.6-21.4 29.8-1 11.5 4.2 22.4 13.1 27.6 4.8 2.8 15.2 5.5 21.4 5.5 12.7 0 18.2 9 21.7 35.5 2.1 15.7 3.3 20.5 5.9 23.3 3.8 4.2 16.6 12.1 22.4 13.9l5.7 1.7-3.5.8c-1.9.5-8.7 1.1-15 1.4-42 2.2-82.6-21.9-101.8-60.1-4-8-9.2-24.6-9.2-29.3 0-4.5 4.7-14.8 8.4-18.1 1.4-1.4 2.6-3.5 2.6-4.7 0-2.9-5.1-8.8-9-10.4-1.6-.7-3-1.8-3-2.4 0-3 4.2-17.9 6.8-24.1 5.4-12.8 4.9-12.2 10.2-12.8 9.7-1.2 19.1-8.3 26.5-20.2 3.8-6.1 4.4-7.7 3.6-9.4-.6-1-1.6-2.2-2.3-2.4-2-.8 2.5-4.1 13.2-9.6 17-8.7 29.9-11.9 48.5-12 6.6 0 15.5.6 19.7 1.4zM338 308c4.9 1.1 11.1 1.9 13.7 1.9 2.6-.1 9.3.4 14.8.9 11.7 1.2 13.6 2.6 15.5 11.6 1.3 6.4 3.2 8.6 6 6.8 1.8-1.1 1.8-1 .3 4.1-5.8 19.6-15 34.5-30.3 49-5.4 5.1-13.3 11.4-17.9 14.1-7.4 4.5-21.2 10.4-28.6 12.2l-3 .7 2.9-2.5c2.8-2.4 3-3.1 3.7-12.9.8-11.9 3.1-19.4 10.4-33.9 4.5-8.9 6.6-12.8 17.9-32.5 7.1-12.3 6.4-13.2-6.9-9.3-6 1.8-7.9 2-9.9 1-2.2-1-2.6-1.8-2.6-5.6 0-3.5.5-4.8 2.2-6 2.7-1.9 1.1-2 11.8.4z\"/>\n\t</svg>\n"]);

  _templateObject46 = function _templateObject46() {
    return data;
  };

  return data;
}

function _templateObject45() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1\" viewBox=\"0 0 600 645\">\n\t\t<path d=\"M47.3 24.7L0 25v200.8c0 110.4.3 223.3.7 250.9l.6 50.3h143.5c136.2 0 143.4-.1 142.7-1.8-2.1-5.4-4.7-17.8-5.2-25.2-.5-7.7.8-18.4 3.3-27.7l.6-2.3H57V297.2c0-95-.3-182.5-.7-194.5L55.7 81h170.8l27.5 27.5 27.5 27.5H501v97c0 76.9.3 97 1.3 97 .6 0 5.5-.9 10.7-2 14.3-3 24.4-2.6 42.8 1.7l2.2.5V78.8l-127 .3-127.1.3-27.7-27.7L248.5 24l-77 .2c-42.4.2-98.3.4-124.2.5z\"/>\n\t\t<path d=\"M280.5 182.6c-37.7 4.4-66.7 20.6-88.6 49.3-7.1 9.4-16.4 28.6-19.5 40.6-3.5 13.1-4.5 39-2 53 8.1 46.9 43.1 85 89.3 97.2 13.3 3.5 36.5 4.3 51.2 1.9 44.4-7.5 81.6-39.2 95.1-81.4 5-15.4 6.3-25.5 5.7-43.7-.4-12.7-1-18-3-25.5-11.3-43.1-45.2-77.2-87.2-88-12.3-3.1-30.2-4.6-41-3.4zm30.7 17.4c8.8 1.8 22 6.2 24 7.9.4.4.1 1.7-.8 2.9-2 2.9-6.2 2.8-10.8-.3-2.1-1.4-5.1-2.5-6.9-2.5-8.1 0-26.6 12.6-28.2 19.3-1.1 4.1.5 5 5 3.1 6.6-2.7 10.5.8 7.4 6.9-3.5 6.8-7.8 8.3-13.9 4.6-6.8-4.2-13-4.5-13-.7 0 2.3-10.1 7.4-16.7 8.4-2.4.3-4.3.9-4.3 1.3s1.4 2 3 3.6c3.8 3.7 3.8 5.2-.2 6.3-7.8 2-5.3 7.2 3.5 7.2 4 0 5.3-.5 7.8-2.9 1.6-1.6 2.9-3.6 2.9-4.5 0-1.8 3-3.6 6-3.6 3.8 0 7.5 2.7 13.7 10.2 3.4 4.3 7.6 8.2 9.7 9.2 4.4 2.1 10.3 1.8 9.7-.4-2.2-7.9 0-12.8 7.3-16.1 3.6-1.6 4.3-1.6 6.8-.3 3.7 1.9 3.5 3.3-1.2 7.9-4.3 4.2-5 6.2-2.5 7.2 2.7 1-1.2 4.2-10 8.4-4.4 2.1-9.3 4.7-11 5.8-4.8 3.3-10.1 1.1-23.2-9.2-9.5-7.5-15.6-10.2-20.7-9.3-6.6 1.2-18 7.2-21.5 11.2-6 6.8-8.5 13.7-8.6 23.4 0 7.3.4 9.2 2.7 13.6 3.3 6.3 9.5 11.7 15.7 13.9 2.5.9 8.6 2 13.4 2.6 10 1 11.7 1.7 14.7 5.9 3.5 4.9 5.7 12.6 8 28 3.4 22.7 3.1 22.1 11.4 28.4 7.9 6 14.5 9.6 17.6 9.6 4.2 0 1.8 1.7-3.2 2.4-15.4 1.8-33.9.1-47.9-4.5-33.8-11-61.3-40.4-70-74.9l-2-7.7 2.1-5.7c1.2-3.1 4-7.9 6.2-10.7 3.1-4 3.8-5.6 3.3-7.6-.8-3.2-5.8-8.1-9.1-8.9-1.7-.4-2.3-1.2-2-2.3.2-.9.7-3.2 1.1-5.1 1.2-6.3 3.6-13.4 7.6-22 4-8.4 4-8.5 7.8-8.6 9.2-.4 20.7-9.3 26.9-20.8 3.7-6.9 3.9-9 1.2-10.9-2.2-1.5-1.8-1.9 11-9.5 7.5-4.4 23.8-9.8 35-11.5 7.8-1.3 25.9-.6 35.2 1.3zm32 108.6c3.3.8 8.5 1.4 11.6 1.4 3.2-.1 10.4.2 16 .7 11.8.9 13.4 2 14.6 9.4 1 6.1 2.4 8.2 5.1 7.7l2.3-.5-1.9 6.6c-2.4 8.4-8.5 21.2-14 29.3-5.6 8.2-19.8 22.9-27.4 28.3-8.7 6.2-22.7 12.9-31 14.9-2.9.7-2.9.7-1-1.4 1.5-1.6 2-4.3 2.6-12.3.4-6.2 1.5-12.7 2.9-16.7 2.6-7.6 10.6-23.9 18.8-38.3 7.6-13.1 10.2-18.3 10.2-20.2 0-2.1-3.5-1.9-10.5.5-9.3 3.2-11.6 2.6-13-3.3-.5-1.8-.2-3.5.9-5.2 2-3 5.1-3.2 13.8-.9zM523 370.1c-12 2-25.7 11.4-31.7 21.7-3.1 5.3-6.3 15.3-6.3 19.8v3.4l-43.1 21.5-43 21.6-2.7-1.9c-17.2-11.7-42.1-8.7-57.4 6.9-17.3 17.7-17.5 45.6-.6 63.5 6.2 6.5 11.5 9.9 19.9 12.5 11.6 3.6 27.1 1.8 37.3-4.4l3.9-2.4 42.7 21 42.8 21 1.1 7.1c2.6 15.4 11.8 27.7 25.7 34.3 6.9 3.3 9 3.8 17 4.1 21.8 1 39.2-10.8 46.5-31.4 1.7-4.8 2-7.7 1.7-15.9-.3-8.7-.8-10.9-3.5-16.8-3.6-7.6-11.6-16.6-18.1-20.4-14.1-8.3-33.4-8.3-47.7 0l-4 2.3-42.7-21.1-42.7-21 42.1-21.4 42-21.3 7.7 3.6c18.7 8.8 38.8 5.7 53-8.2 18.3-18 18.4-47 .3-65.1-10.8-10.8-25.3-15.5-40.2-13z\"/>\n\t</svg>\n"]);

  _templateObject45 = function _templateObject45() {
    return data;
  };

  return data;
}

function _templateObject44() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg\n\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\twidth=\"32\"\n\t\theight=\"32\"\n\t\tviewBox=\"0 0 32 32\"\n\t>\n\t\t<path\n\t\t\td=\"M275 59.3V100h-8.9c-28 0-63 9-92.1 23.5-44.6 22.3-80.3 58.7-102 103.7-15.5 32.3-22 61.2-22 97.8 0 36.6 6.5 65.5 22 97.8 29.1 60.5 84.1 105.2 149 121.1 18.1 4.4 33.3 6.1 54.3 6.1 29.1-.1 49.9-3.6 76.7-13.2 9.2-3.3 32-13.8 32-14.7 0-.4-8.4-9-18.7-19.3l-18.8-18.7-9.5 3.6c-11.3 4.2-28.5 8.7-39.5 10.3-11.2 1.5-36.2 1.3-47.7-.5-76.7-11.7-135.7-70.7-147.3-147.5-1.9-12.2-1.9-37.8 0-50 12.4-81.7 79.6-144 160.7-148.8l11.8-.7v81l53.2-53.3 53.3-53.2-53.3-53.2L275 18.5v40.8z\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M334.7 240.8C290.3 285.2 254 322 254 322.5c0 .6 36.5 37.5 81 82l81 81 81.5-81.5 81.6-81.6-80.7-81.2c-44.3-44.7-81.1-81.2-81.7-81.2-.7 0-37.5 36.3-82 80.8zm127.1 126.9L416.5 413l-45.2-45.2-45.3-45.3 45.2-45.2 45.3-45.3 45.2 45.2 45.3 45.3-45.2 45.2z\"\n\t\t/>\n\t</svg>\n"]);

  _templateObject44 = function _templateObject44() {
    return data;
  };

  return data;
}

function _templateObject43() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n\t\t<path fill=\"none\" d=\"M0 0h24v24H0z\" />\n\t\t<path\n\t\t\td=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z\"\n\t\t/>\n\t</svg>\n"]);

  _templateObject43 = function _templateObject43() {
    return data;
  };

  return data;
}

function _templateObject42() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n\t\t<path\n\t\t\tfill=\"none\"\n\t\t\tstroke=\"#000\"\n\t\t\tstroke-miterlimit=\"10\"\n\t\t\tstroke-width=\"2\"\n\t\t\td=\"M20 12v7c0 .552-.448 1-1 1H5c-.552 0-1-.448-1-1V5c0-.552.448-1 1-1h7M20 10V4h-6M20 4L9 15\"\n\t\t/>\n\t</svg>\n"]);

  _templateObject42 = function _templateObject42() {
    return data;
  };

  return data;
}

function _templateObject41() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg\n\t\tversion=\"1.1\"\n\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\txmlns:xlink=\"http://www.w3.org/1999/xlink\"\n\t\tx=\"0px\"\n\t\ty=\"0px\"\n\t\twidth=\"24px\"\n\t\theight=\"24px\"\n\t\tviewBox=\"0 0 24 24\"\n\t\tenable-background=\"new 0 0 24 24\"\n\t\txml:space=\"preserve\"\n\t>\n\t\t<g id=\"Bounding_Boxes\">\n\t\t\t<g id=\"ui_x5F_spec_x5F_header_copy_3\"></g>\n\t\t\t<path fill=\"none\" d=\"M0,0h24v24H0V0z\" />\n\t\t</g>\n\t\t<g id=\"Outline\">\n\t\t\t<g id=\"ui_x5F_spec_x5F_header\"></g>\n\t\t\t<path d=\"M7.41,8.59L12,13.17l4.59-4.58L18,10l-6,6l-6-6L7.41,8.59z\" />\n\t\t</g>\n\t</svg>\n"]);

  _templateObject41 = function _templateObject41() {
    return data;
  };

  return data;
}

function _templateObject40() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg width=\"24\" height=\"24\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n\t\t<path fill=\"none\" d=\"M0 0h24v24H0z\" />\n\t\t<path\n\t\t\td=\"M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8\n\t\t5 8-5v10zm-8-7L4 6h16l-8 5z\"\n\t\t/>\n\t</svg>\n"]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg\n\t\tversion=\"1.1\"\n\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\txmlns:xlink=\"http://www.w3.org/1999/xlink\"\n\t\tx=\"0px\"\n\t\ty=\"0px\"\n\t\twidth=\"24px\"\n\t\theight=\"24px\"\n\t\tviewBox=\"0 0 24 24\"\n\t\tenable-background=\"new 0 0 24 24\"\n\t\txml:space=\"preserve\"\n\t>\n\t\t<g id=\"Bounding_Boxes\"><path fill=\"none\" d=\"M0,0h24v24H0V0z\" /></g>\n\t\t<g id=\"Sharp\">\n\t\t\t<path\n\t\t\t\td=\"M22,9.24l-7.19-0.62L12,2L9.19,8.63L2,9.24l5.46,4.73L5.82,21L12,17.27L18.18,21l-1.63-7.03L22,\n\t\t\t9.24z M12,15.4l-3.76,2.27 l1-4.28l-3.32-2.88l4.38-0.38L12,6.1l1.71,4.04l4.38,0.38l-3.32,2.88l1,4.28L12,15.4z\"\n\t\t\t/>\n\t\t</g>\n\t</svg>\n"]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg\n\t\tversion=\"1.1\"\n\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\txmlns:xlink=\"http://www.w3.org/1999/xlink\"\n\t\twidth=\"24\"\n\t\theight=\"24\"\n\t\tviewBox=\"-293 385 24 24\"\n\t\txml:space=\"preserve\"\n\t>\n\t\t<g id=\"Rounded\">\n\t\t\t<g id=\"ui_x5F_spec_x5F_header_copy_5\" display=\"none\"></g>\n\t\t\t<g id=\"XMLID_1_\">\n\t\t\t\t<path\n\t\t\t\t\td=\"M-281,385c-6.6,0-12,5.4-12,12s5.4,12,12,12s12-5.4,12-12S-274.4,385-281,385z M-273.9,399.6l-4.1,4.1\n\t\tc-0.5,0.5-1.1,0.7-1.7,0.7h-4.4c-1.3,0-2.4-1.1-2.4-2.4v-8.7c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9v3c0,0.2,0.1,0.3,0.3,0.3\n\t\tc0.2,0,0.3-0.1,0.3-0.3v-4.8c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9v4.8c0,0.2,0.1,0.3,0.3,0.3s0.3-0.1,0.3-0.3v-5.4\n\t\tc0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9v5.4c0,0.2,0.1,0.3,0.3,0.3c0.2,0,0.3-0.1,0.3-0.3v-3.6c0-0.5,0.4-0.9,0.9-0.9\n\t\ts0.9,0.4,0.9,0.9v6.9l2.5-1.4c0.1-0.1,0.3-0.1,0.4-0.1c0.2,0,0.5,0.1,0.6,0.3C-273.6,398.6-273.6,399.2-273.9,399.6z\"\n\t\t\t\t/>\n\t\t\t</g>\n\t\t</g>\n\t</svg>\n"]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = (0, _taggedTemplateLiteral2.default)(["<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n\t<path d=\"M0 0h24v24H0z\" fill=\"none\"/>\n\t<path d=\"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z\"/>\n</svg>"]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = (0, _taggedTemplateLiteral2.default)(["<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n\t<path d=\"M0 0h24v24H0z\" fill=\"none\"/>\n\t<path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z\"/>\n</svg>"]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M27 18c1-1 1.8-2.2 1.8-3.8 0-2.6-2.2-4.8-4.6-4.8s-4.8 2.2-4.8 4.8c0 1.4 0.6 2.6 1.4 3.4-0.6 0.2-1 0.2-1.4 0.4-1-1-2.8-1.8-5.2-2.2 1.8-1 3-3 3-5.2 0-3.4-2.8-6.2-6.2-6.2s-6 2.8-6 6.2c0 2.2 1 4 2.8 5-6.8 1-7.8 4.6-7.8 6.8v5h32v-4.2c0-1.6-0.8-4.4-5-5.2zM24 12c1 0 2 1 2 2.2s-1 2.2-2 2.2-2-1-2-2.2 1-2.2 2-2.2zM11 7.2c1.8 0 3.4 1.6 3.4 3.4s-1.6 3.4-3.4 3.4-3.6-1.6-3.6-3.4c0-1.8 1.6-3.4 3.6-3.4zM16 24.8h-13.4v-2.4c0-2.8 2.6-4.2 8-4.2s8 1.4 8 4.2v2.4h-2.6zM29.4 24.8h-8v-2.4c0-0.6-0.2-1.4-0.4-2.2 0.6-0.2 1.4-0.2 2.4-0.2 6 0 6 2.2 6 3v1.8z\"></path>\n\t</svg>"]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M20.4 16.2c2.6-1.4 4.4-4.4 4.4-7.6 0-4.6-4-8.6-8.8-8.6s-8.8 4-8.8 8.8c0 3.2 1.8 6 4.4 7.6-8.8 1.2-10.2 6-10.2 9v6.6h29.2v-6.6c0-3.2-1.6-8-10.2-9.2zM16 3c3.2 0 5.8 2.6 5.8 5.8s-2.6 5.8-5.8 5.8-5.8-2.6-5.8-5.8 2.6-5.8 5.8-5.8zM27.6 29h-3v-4.4h-3v4.4h-11.4v-4.4h-3v4.4h-2.8v-3.8c0-4.2 4-6.4 11.6-6.4s11.6 2.2 11.6 6.4v3.8z\"></path>\n\t</svg>"]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M32 12.4l-11-1.4-5-10.2-5 10.2-11 1.4 7.8 7.8-1.6 11 9.8-5.2 9.8 5.2-1.6-11z\"></path>\n\t</svg>"]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M27 22c-1.411 0-2.685 0.586-3.594 1.526l-13.469-6.734c0.041-0.258 0.063-0.522 0.063-0.791s-0.022-0.534-0.063-0.791l13.469-6.734c0.909 0.94 2.183 1.526 3.594 1.526 2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5c0 0.269 0.022 0.534 0.063 0.791l-13.469 6.734c-0.909-0.94-2.183-1.526-3.594-1.526-2.761 0-5 2.239-5 5s2.239 5 5 5c1.411 0 2.685-0.586 3.594-1.526l13.469 6.734c-0.041 0.258-0.063 0.522-0.063 0.791 0 2.761 2.239 5 5 5s5-2.239 5-5c0-2.761-2.239-5-5-5z\"></path>\n\t</svg>"]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<g transform=\"scale(2)\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n\t\t\t<path d=\"m3.5 3.5v-3h9v3\"/>\n\t\t\t<path d=\"m3.5 12.5h-3v-7h15v7h-3\"/>\n\t\t\t<path d=\"m3.5 9.5h9v6h-9z\"/>\n\t\t</g>\n\t</svg>"]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M18.4 12.2l-7.8-0.2v3h1.6l-0.2 9.4h-1.6v1.6h6.2v-1.6h-1.6v-3h3c2.6 0 4.6-2 4.8-4.6s-1.8-4.6-4.4-4.6zM18.2 18.4h-3v-3h3c0.8 0 1.6 0.8 1.6 1.6 0 0.6-0.6 1.4-1.6 1.4zM28.8 6.4l-8.4-6.4h-17.2v32h25.6v-25.6zM6.4 28.8v-25.6h12.8v6.4h6.4v19.2h-19.2z\"></path>\n\t</svg>"]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M4 14h24v4h-24v-4zM14 4h4v24h-4v-24z\"></path>\n\t</svg>"]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M32 10.4v11.2c0 2-1.8 3.8-4 3.8h-24c-2.2 0-4-1.6-4-3.8v-11.2c0-2 1.8-3.8 4-3.8h24c2.2 0.2 4 1.8 4 3.8zM3.2 20h1.8v-5l3.4 5h1.8v-8h-1.8v5l-3.6-5h-1.6v8zM12.6 20h5.4v-1.6h-3.6v-1.8h3.6v-1.4h-3.6v-1.6h3.8v-1.6h-5.6v8zM25.8 12h-2l-1.4 5.2-1-5.2h-1.8l2 8h1.6l1.6-6 1.6 6h1.6l2-8h-1.8l-1.2 5.2-1.2-5.2z\"></path>\n\t</svg>"]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M4 14h24v4h-24v-4z\"></path>\n\t</svg>"]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M24 12.8v-4.8c0-4.4-3.6-8-8-8s-8 3.4-8 7.6v5.2h-4.8v19.2h25.6v-19.2h-4.8zM11.2 7.6c0-2.8 2.4-4.4 4.8-4.4 2.6 0 4.8 2.2 4.8 4.8v4.8h-9.6v-5.2zM25.6 28.8h-19.2v-12.8h19.2v12.8zM14.4 19.2h3.2v6.4h-3.2v-6.4z\"></path>\n\t</svg>"]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zM13.8 5.6h5v5h-5v-5zM21.4 25.8h-10.2v-2.6h2.6v-7.6h-2.6v-2.4h7.6v10.2h2.6v2.4z\"></path>\n\t</svg>"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M0 2h32v4h-32v-4zM0 14h32v4h-32v-4zM0 26h32v4h-32v-4z\"></path>\n\t</svg>"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M17.4 4.8l-3.2-3.2h-14.2v28.8h32v-25.6h-14.6zM28.8 27.2h-25.6v-22.4h9.8l3.2 3.2h12.6v19.2z\"></path>\n\t</svg>"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M17.4 4.8l-3.2-3.2h-14.2v28.8h32v-25.6h-14.6zM28.8 27.2h-25.6v-22.4h9.8l3.2 3.2h12.6v19.2zM8 21.2h10.6v2.6h-10.6v-2.6zM23.8 18.6h-15.8v-2.6h15.8v2.6zM23.8 13.2h-15.8v-2.6h15.8v2.6z\"></path>\n\t</svg>"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" role=\"presentation\" aria-hidden=\"true\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M20.4 0h-17.2v32h25.6v-25.6l-8.4-6.4zM25.6 28.8h-19.2v-25.6h12.8v6.4h6.4v19.2z\"></path>\n\t</svg>"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" role=\"presentation\" aria-hidden=\"true\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M19.047 16.2h1l-1.2 5.2-1.6-7.4h-2.4l-1.8 7.4-1.4-7.4h-2.6l2.6 12h2.6l1.8-7 1.6 7h2.4l3-12h-4v2.2zM20.447 0h-17.2v32h25.6v-25.6c0 0-8.4-6.4-8.4-6.4zM25.647 28.8h-19.2v-25.6h12.8v6.4h6.4v19.2z\"></path>\n\t</svg>"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" role=\"presentation\" aria-hidden=\"true\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M23.4 20c-0.6-0.2-1.3-0.4-2-0.4-0.8 0-1.6 0-2.4 0.2-0.6-0.4-2.8-2.2-3.2-4.2 0-0.2 0-0.2 0-0.4 0 0 0.5-2.8 0.4-3.8 0-0.6-0.6-0.8-1-0.8h-0.2c-0.4 0-0.9 0.1-1 0.6-0.2 1.2 0 2.8 0.6 5 0 0-2.2 4.8-2.6 5.6 0 0-0.9 0.3-1.4 0.6-0.8 0.4-2.2 1.8-2.4 2.4-0.1 1 1 1 1.2 1 1 0 2-1.2 3.6-3.8 1.8-0.6 3.8-1 5.6-1.4 1.4 0.8 3 1.2 4 1.2 1.9-0.1 1.5-1.5 0.8-1.8zM9 25c0.2-0.4 0.8-1.4 1.8-2.2 0 0 0.2-0.2 0.4-0.4-1 1.8-1.6 2.4-2.2 2.6zM15.2 11.2c0.4 0 0.5 0.8 0.4 1.4-0.1 0.9-0.2 1.2-0.4 1.6-0.2-0.6-0.2-1.4-0.2-2 0 0 0-1 0.2-1zM13.4 21v0c0.2-0.4 1.4-3 1.8-3.6 0.6 1 1.2 1.8 2 2.4l0.2 0.2c-1.6 0.2-3 0.6-4 1zM23 20.9c0 0.4-1.4 0.5-2.8-0.5 2.4-0.3 2.8 0.1 2.8 0.5zM20.4 0h-17.2v32h25.6v-25.6c0 0-8.4-6.4-8.4-6.4zM25.6 28.8h-19.2v-25.6h12.8v6.4h6.4v19.2z\"></path>\n\t</svg>"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" role=\"presentation\" aria-hidden=\"true\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M20.4 0h-17.2v32h25.6v-25.6l-8.4-6.4zM25.6 28.8h-19.2v-25.6h12.8v6.4h6.4v19.2zM24.4 27.2h-16.8v-3.2l5-8.4 7 8.4 4.8-3.4v1.6zM24.4 16.4c0 1.436-1.164 2.6-2.6 2.6s-2.6-1.164-2.6-2.6c0-1.436 1.164-2.6 2.6-2.6s2.6 1.164 2.6 2.6z\"></path>\n\t</svg>"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" role=\"presentation\" aria-hidden=\"true\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M22.4 0h-19.2v32h25.6v-23.6l-6.4-8.4zM26 29.2h-20v-26.4h13.8v6.4h6.2v20zM8 23.2h10.6v2.6h-10.6v-2.6zM8 18h15.8v2.6h-15.8v-2.6zM8 12.6h15.8v2.6h-15.8v-2.6z\"></path>\n\t</svg>"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" role=\"presentation\" aria-hidden=\"true\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M21.8 12.4h-3.4l-2.4 3.6-2.4-3.6h-3.4l4 6-4.6 6.6h6.6v-2.2h-1.4l1.2-1.8 2.8 4.2h3.4l-4.4-6.8 4-6zM20.4 0h-17.2v32h25.6v-25.6c0 0-8.4-6.4-8.4-6.4zM25.6 28.8h-19.2v-25.6h12.8v6.4h6.4v19.2z\"></path>\n\t</svg>"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M-0.2 0v32h32v-32h-32zM29.8 30h-28v-28h28v28zM15 24h2v-7h7v-2h-7v-7h-2v7h-7v2h7z\"></path>\n\t</svg>"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\">\n\t\t<circle cx=\"50%\" cy=\"50%\" r=\"3\"/>\n\t</svg>"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M-0.2 0v32h32v-32h-32zM29.8 30h-28v-28h28v28zM8 15h16v2h-16v-2z\"></path>\n\t</svg>"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<g transform=\"scale(2)\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\">\n\t\t\t<path d=\"m13.5 2.5-11 11\" data-cap=\"butt\"/>\n\t\t\t<path d=\"m2.5 2.5 11 11\" data-cap=\"butt\"/>\n\t\t</g>\n\t</svg>"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M30 4.8l-2.8-2.8-11.2 11.2-11.2-11.2-2.8 2.8 11.2 11.2-11.2 11.2 2.8 2.8 11.2-11.2 11.2 11.2 2.8-2.8-11.2-11.2z\"></path>\n\t</svg>"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t<path d=\"M21.6 16l10-10c0.4-0.4 0.4-1 0-1.4l-4.2-4.2c-0.4-0.4-1-0.4-1.4-0.2l-10 10-10-10c-0.4-0.2-1-0.2-1.4 0l-4.4 4.4c-0.2 0.4-0.2 1 0 1.4l10 10-10 10c-0.4 0.4-0.4 1 0 1.4l4.2 4.2c0.6 0.4 1.2 0.4 1.6 0.2l10-10 10 10c0.4 0.4 1 0.4 1.4 0l4.2-4.2c0.4-0.4 0.4-1 0-1.4l-10-10.2z\"></path>\n</svg>"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"spa-icon-cpefile\" viewBox=\"0 0 817.762 1021.205\"><path d=\"M715.043 919.484H102.72V101.722h407.884v204.44h204.44v613.322zM549.496 0H0v1021.205h817.762V204.44L549.496 0z\" class=\"spa-icon-cpefile-doc-outline\"/>\n\t\t<path fill=\"#FFF\" d=\"M715.881 919.603h-612v-818h407.668v204.5h204.332z\" class=\"spa-icon-cpefile-doc\"/>\n\t\t<g class=\"spa-icon-cpefile-ce\">\n\t\t\t<path d=\"M444.881 408.706l183.802-.103.015 48.877-124.716-.043-.015 55.185 116.922.042v52.624H503.135v59.579h125.746V676.5l-184 .103V408.706z\" class=\"spa-icon-cpefile-e\"/>\n\t\t\t<path d=\"M196.554 483.981c6.45-17.325 15.518-31.892 27.205-43.715 11.689-11.816 25.795-20.88 42.32-27.195 16.525-6.308 34.724-9.468 54.612-9.468 17.734 0 33.25 1.612 46.551 4.835 13.3 3.223 23.843 6.849 31.639 10.878l-8.867 46.333c-7.796-3.223-16.865-5.905-27.205-8.058-10.347-2.146-20.09-3.224-29.22-3.224-28.755 0-50.583 7.19-65.495 21.556-14.912 14.372-22.368 36.6-22.368 66.68 0 30.085 7.456 52.313 22.368 66.68 14.912 14.372 36.74 21.554 65.494 21.554 9.132 0 18.874-1.07 29.22-3.223 10.341-2.146 19.41-4.834 27.206-8.058l8.867 46.333c-7.796 4.03-18.338 7.656-31.639 10.879-13.3 3.223-28.817 4.835-46.551 4.835-19.888 0-38.087-3.16-54.612-9.469-16.525-6.308-30.631-15.373-42.32-27.195-11.688-11.816-20.756-26.39-27.205-43.715-6.448-17.324-9.673-36.865-9.673-58.622 0-21.756 3.225-41.296 9.673-58.62z\" class=\"spa-icon-cpefile-c\"/>\n\t\t</g>\n\t</svg>\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n\t\t<title>13246F81-8BD0-4021-86AC-60F868057A1F@1x</title>\n\t\t<g id=\"Navigation\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n\t\t\t\t<g id=\"6.19-/-Questionnaire---Business\" transform=\"translate(-36.000000, -411.000000)\">\n\t\t\t\t\t\t<path d=\"M44,411 C48.418278,411 52,414.581722 52,419 C52,423.418278 48.418278,427 44,427 C39.581722,427 36,423.418278 36,419 C36,414.581722 39.581722,411 44,411 Z M48.1128005,415.640801 C47.7303253,415.333043 47.1707808,415.393613 46.8630229,415.776088 L46.8630229,415.776088 L43.1697778,420.366222 L41.0494233,418.396091 L40.9630185,418.325278 C40.6045719,418.067163 40.1016154,418.110353 39.7931964,418.44236 C39.4590758,418.802035 39.4797912,419.364467 39.8394656,419.698587 L39.8394656,419.698587 L42.6591212,422.317915 L42.743258,422.387113 C43.1207869,422.660938 43.6563996,422.597035 43.9566327,422.223912 L43.9566327,422.223912 L48.2480882,416.890578 L48.312592,416.799367 C48.5446228,416.423509 48.4658546,415.924885 48.1128005,415.640801 Z\" id=\"small-check\"></path>\n\t\t\t\t</g>\n\t\t</g>\n\t</svg>\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M14 29.4l-13.4-10.6 2.4-3 10.2 8.2 15-21.4 3.2 2.4zM14 30l-14-11 2.8-3.8 10.2 8 15.2-21.2 3.8 3-18 25zM1.4 18.8l12.6 9.8 16.8-23.6-2.4-1.8-15 21.4-10.4-8.2-1.6 2.4z\"></path>\n\t</svg>"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M29.8 2v28h-28v-28h28zM31.8 0h-32v32h32v-32z\"></path>\n\t</svg>"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M25.6 9.2l-2-1.6-9.4 13.4-6.4-5-1.4 1.8 8.4 6.6zM-0.2 0v32h32v-32h-32zM29.8 30h-28v-28h28v28z\"></path>\n\t</svg>"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M20.8 22.4h3.2v3.2h-3.2v-3.2zM8 22.4h3.2v3.2h-3.2v-3.2zM14.4 22.4h3.2v3.2h-3.2v-3.2zM20.8 16h3.2v3.2h-3.2v-3.2zM8 16h3.2v3.2h-3.2v-3.2zM14.4 16h3.2v3.2h-3.2v-3.2zM28.8 3.2h-4.8v-3.2h-3.2v3.2h-9.6v-3.2h-3.2v3.2h-8v28.8h32v-28.8h-3.2zM28.8 28.8h-25.6v-16h25.6v16z\"></path>\n\t</svg>"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M11.6 1.4v7.4h-11.6v21.8h32v-29.2h-20.4zM3 27.6v-16h8.8v16h-8.8zM29 27.6h-14.4v-23.2h14.6v23.2zM23.2 7.2h3v4.4h-3v-4.4zM17.4 7.2h3v4.4h-3v-4.4zM5.8 14.6h3v4.4h-3v-4.4zM17.4 14.6h3v4.4h-3v-4.4zM23.2 14.6h3v4.4h-3v-4.4z\"></path>\n\t</svg>"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M6.8 19h7.2v-2h4v2h7.2l6.8-6.8v-3.2c0-1-1-2-2-2h-6l-4-4h-8l-4 4h-6c-1 0-2 1-2 2v3.2l6.8 6.8zM12.8 5h6.4l2 2h-10.4l2-2zM26 21h-8v2h-4v-2h-8l-6-6v12c0 1 1 2 2 2h28c1 0 2-1 2-2v-12l-6 6z\"></path>\n\t</svg>"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n\t\t<path d=\"M16 0.2c-8.8 0-15.8 7-15.8 15.8s7 15.8 15.8 15.8 15.8-7 15.8-15.8-7.2-15.8-15.8-15.8zM24.8 18c0 0.4-0.2 0.6-0.6 0.6h-5.6v6c0 0.4-0.2 0.6-0.6 0.6h-4c-0.4 0-0.6-0.2-0.6-0.6v-6h-6c-0.2 0-0.6-0.2-0.6-0.6v-4c0-0.4 0.2-0.6 0.6-0.6h5.8v-5.8c0-0.4 0.2-0.6 0.6-0.6h4c0.4 0 0.6 0.2 0.6 0.6v5.8h5.8c0.4 0 0.6 0.2 0.6 0.6v4z\"></path>\n\t</svg>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var add = (0, _element.svg)(_templateObject());
exports.add = add;
var briefcase = (0, _element.svg)(_templateObject2());
exports.briefcase = briefcase;
var buildings = (0, _element.svg)(_templateObject3());
exports.buildings = buildings;
var calendar = (0, _element.svg)(_templateObject4());
exports.calendar = calendar;
var checkboxFilled = (0, _element.svg)(_templateObject5());
exports.checkboxFilled = checkboxFilled;
var checkbox = (0, _element.svg)(_templateObject6());
exports.checkbox = checkbox;
var checkmark = (0, _element.svg)(_templateObject7());
exports.checkmark = checkmark;
var checkmarkFilledCircle = (0, _element.svg)(_templateObject8());
exports.checkmarkFilledCircle = checkmarkFilledCircle;
var checkpointEngage = (0, _element.svg)(_templateObject9());
exports.checkpointEngage = checkpointEngage;
var close = (0, _element.svg)(_templateObject10());
exports.close = close;
var closeX = (0, _element.svg)(_templateObject11());
exports.closeX = closeX;
var closeXThin = (0, _element.svg)(_templateObject12());
exports.closeXThin = closeXThin;
var collapse = (0, _element.svg)(_templateObject13());
exports.collapse = collapse;
var dot = (0, _element.svg)(_templateObject14());
exports.dot = dot;
var expand = (0, _element.svg)(_templateObject15());
exports.expand = expand;
var fileExcel = (0, _element.svg)(_templateObject16());
exports.fileExcel = fileExcel;
var fileFilled = (0, _element.svg)(_templateObject17());
exports.fileFilled = fileFilled;
var fileImage = (0, _element.svg)(_templateObject18());
exports.fileImage = fileImage;
var filePdf = (0, _element.svg)(_templateObject19());
exports.filePdf = filePdf;
var fileWord = (0, _element.svg)(_templateObject20());
exports.fileWord = fileWord;
var file = (0, _element.svg)(_templateObject21());
exports.file = file;
var folderFilled = (0, _element.svg)(_templateObject22());
exports.folderFilled = folderFilled;
var folder = (0, _element.svg)(_templateObject23());
exports.folder = folder;
var hamburgerMenu = (0, _element.svg)(_templateObject24());
exports.hamburgerMenu = hamburgerMenu;
var info = (0, _element.svg)(_templateObject25());
exports.info = info;
var lock = (0, _element.svg)(_templateObject26());
exports.lock = lock;
var minusPlain = (0, _element.svg)(_templateObject27());
exports.minusPlain = minusPlain;
var newIcon = (0, _element.svg)(_templateObject28());
exports.newIcon = newIcon;
var plusPlain = (0, _element.svg)(_templateObject29());
exports.plusPlain = plusPlain;
var filePowerPoint = (0, _element.svg)(_templateObject30());
exports.filePowerPoint = filePowerPoint;
var print = (0, _element.svg)(_templateObject31());
exports.print = print;
var share = (0, _element.svg)(_templateObject32());
exports.share = share;
var star = (0, _element.svg)(_templateObject33());
exports.star = star;
var user = (0, _element.svg)(_templateObject34());
exports.user = user;
var users = (0, _element.svg)(_templateObject35());
exports.users = users;
var success = (0, _element.svg)(_templateObject36());
exports.success = success;
var danger = (0, _element.svg)(_templateObject37());
exports.danger = danger;
var panTool = (0, _element.html)(_templateObject38());
exports.panTool = panTool;
var starBorder = (0, _element.html)(_templateObject39());
exports.starBorder = starBorder;
var mailOutline = (0, _element.html)(_templateObject40());
exports.mailOutline = mailOutline;
var dropdownArrow = (0, _element.html)(_templateObject41());
exports.dropdownArrow = dropdownArrow;
var externalLink = (0, _element.html)(_templateObject42());
exports.externalLink = externalLink;
var help = (0, _element.html)(_templateObject43());
exports.help = help;
var rotate90 = (0, _element.svg)(_templateObject44());
exports.rotate90 = rotate90;
var folderGlobeShare = (0, _element.svg)(_templateObject45());
exports.folderGlobeShare = folderGlobeShare;
var folderGlobe = (0, _element.svg)(_templateObject46());
exports.folderGlobe = folderGlobe;
var exit = (0, _element.svg)(_templateObject47());
exports.exit = exit;
var accountingApp = (0, _element.svg)(_templateObject48());
exports.accountingApp = accountingApp;
var activityStatementsApp = (0, _element.svg)(_templateObject49());
exports.activityStatementsApp = activityStatementsApp;
var advisoryApp = (0, _element.svg)(_templateObject50());
exports.advisoryApp = advisoryApp;
var checkpointEngageApp = (0, _element.svg)(_templateObject51());
exports.checkpointEngageApp = checkpointEngageApp;
var companyFormationsApp = (0, _element.svg)(_templateObject52());
exports.companyFormationsApp = companyFormationsApp;
var fixedAssetsApp = (0, _element.svg)(_templateObject53());
exports.fixedAssetsApp = fixedAssetsApp;
var grossIncomeTaxApp = (0, _element.svg)(_templateObject54());
exports.grossIncomeTaxApp = grossIncomeTaxApp;
var investmentAccountsApp = (0, _element.svg)(_templateObject55());
exports.investmentAccountsApp = investmentAccountsApp;
var noApp = (0, _element.svg)(_templateObject56());
exports.noApp = noApp;
var secretarialApp = (0, _element.svg)(_templateObject57());
exports.secretarialApp = secretarialApp;
var taxAmnestyApp = (0, _element.svg)(_templateObject58());
exports.taxAmnestyApp = taxAmnestyApp;
var taxApp = (0, _element.svg)(_templateObject59());
exports.taxApp = taxApp;
var trialBalanceEstudioContableApp = (0, _element.svg)(_templateObject60());
exports.trialBalanceEstudioContableApp = trialBalanceEstudioContableApp;
var trialBalanceApp = (0, _element.svg)(_templateObject61());
exports.trialBalanceApp = trialBalanceApp;
var ultraTaxApp = (0, _element.svg)(_templateObject62());
exports.ultraTaxApp = ultraTaxApp;
var vatApp = (0, _element.svg)(_templateObject63());
exports.vatApp = vatApp;
var workpapersApp = (0, _element.svg)(_templateObject64());
exports.workpapersApp = workpapersApp;
var IconType;
exports.IconType = IconType;

(function (IconType) {
  IconType["AccountingApp"] = "accountingApp";
  IconType["ActivityStatementsApp"] = "activityStatementsApp";
  IconType["Add"] = "add";
  IconType["AdvisoryApp"] = "advisoryApp";
  IconType["Briefcase"] = "briefcase";
  IconType["Buildings"] = "buildings";
  IconType["Calendar"] = "calendar";
  IconType["Checkbox"] = "checkbox";
  IconType["CheckboxFilled"] = "checkboxFilled";
  IconType["Checkmark"] = "checkmark";
  IconType["CheckmarkFilledCircle"] = "checkmarkFilledCircle";
  IconType["CheckpointEngage"] = "checkpointEngage";
  IconType["CheckpointEngageApp"] = "checkpointEngageApp";
  IconType["Close"] = "close";
  IconType["CloseX"] = "closeX";
  IconType["CloseXThin"] = "closeXThin";
  IconType["Collapse"] = "collapse";
  IconType["CompanyFormationsApp"] = "companyFormationsApp";
  IconType["Danger"] = "danger";
  IconType["Dot"] = "dot";
  IconType["DropdownArrow"] = "dropdownArrow";
  IconType["Exit"] = "exit";
  IconType["Expand"] = "expand";
  IconType["ExternalLink"] = "externalLink";
  IconType["File"] = "file";
  IconType["FileExcel"] = "fileExcel";
  IconType["FileFilled"] = "fileFilled";
  IconType["FileImage"] = "fileImage";
  IconType["FilePdf"] = "filePdf";
  IconType["filePowerPoint"] = "filePowerPoint";
  IconType["FileWord"] = "fileWord";
  IconType["FixedAssetsApp"] = "fixedAssetsApp";
  IconType["Folder"] = "folder";
  IconType["FolderFilled"] = "folderFilled";
  IconType["FolderGlobeShare"] = "folderGlobeShare";
  IconType["FolderGlobe"] = "folderGlobe";
  IconType["GrossIncomeTaxApp"] = "grossIncomeTaxApp";
  IconType["HamburgerMenu"] = "hamburgerMenu";
  IconType["Help"] = "help";
  IconType["Info"] = "info";
  IconType["InvestmentAccountsApp"] = "investmentAccountsApp";
  IconType["Lock"] = "lock";
  IconType["MailOutline"] = "mailOutline";
  IconType["MinusPlain"] = "minusPlain";
  IconType["NewIcon"] = "newIcon";
  IconType["NoApp"] = "noApp";
  IconType["PanTool"] = "panTool";
  IconType["PlusPlain"] = "plusPlain";
  IconType["Print"] = "print";
  IconType["Rotate90"] = "rotate90";
  IconType["SecretarialApp"] = "secretarialApp";
  IconType["Share"] = "share";
  IconType["Star"] = "star";
  IconType["StarBorder"] = "starBorder";
  IconType["Success"] = "success";
  IconType["TaxAmnestyApp"] = "taxAmnestyApp";
  IconType["TaxApp"] = "taxApp";
  IconType["TrialBalanceEstudioContableApp"] = "trialBalanceEstudioContableApp";
  IconType["TrialBalanceApp"] = "trialBalanceApp";
  IconType["UltraTaxApp"] = "ultraTaxApp";
  IconType["User"] = "user";
  IconType["Users"] = "users";
  IconType["VatApp"] = "vatApp";
  IconType["WorkpapersApp"] = "workpapersApp";
})(IconType || (exports.IconType = IconType = {}));

function iconForType(type) {
  switch (type) {
    case IconType.AccountingApp:
      return accountingApp;

    case IconType.ActivityStatementsApp:
      return activityStatementsApp;

    case IconType.Add:
      return add;

    case IconType.AdvisoryApp:
      return advisoryApp;

    case IconType.Briefcase:
      return briefcase;

    case IconType.Buildings:
      return buildings;

    case IconType.Calendar:
      return calendar;

    case IconType.Checkbox:
      return checkbox;

    case IconType.CheckboxFilled:
      return checkboxFilled;

    case IconType.Checkmark:
      return checkmark;

    case IconType.CheckmarkFilledCircle:
      return checkmarkFilledCircle;

    case IconType.CheckpointEngage:
      return checkpointEngage;

    case IconType.CheckpointEngageApp:
      return checkpointEngageApp;

    case IconType.Close:
      return close;

    case IconType.CloseX:
      return closeX;

    case IconType.CloseXThin:
      return closeXThin;

    case IconType.Collapse:
      return collapse;

    case IconType.CompanyFormationsApp:
      return companyFormationsApp;

    case IconType.Danger:
      return danger;

    case IconType.Dot:
      return dot;

    case IconType.DropdownArrow:
      return dropdownArrow;

    case IconType.Exit:
      return exit;

    case IconType.Expand:
      return expand;

    case IconType.ExternalLink:
      return externalLink;

    case IconType.File:
      return file;

    case IconType.FileExcel:
      return fileExcel;

    case IconType.FileFilled:
      return fileFilled;

    case IconType.FileImage:
      return fileImage;

    case IconType.FilePdf:
      return filePdf;

    case IconType.filePowerPoint:
      return filePowerPoint;

    case IconType.FileWord:
      return fileWord;

    case IconType.FixedAssetsApp:
      return fixedAssetsApp;

    case IconType.Folder:
      return folder;

    case IconType.FolderFilled:
      return folderFilled;

    case IconType.FolderGlobeShare:
      return folderGlobeShare;

    case IconType.FolderGlobe:
      return folderGlobe;

    case IconType.GrossIncomeTaxApp:
      return grossIncomeTaxApp;

    case IconType.HamburgerMenu:
      return hamburgerMenu;

    case IconType.Help:
      return help;

    case IconType.Info:
      return info;

    case IconType.InvestmentAccountsApp:
      return investmentAccountsApp;

    case IconType.Lock:
      return lock;

    case IconType.MailOutline:
      return mailOutline;

    case IconType.MinusPlain:
      return minusPlain;

    case IconType.NewIcon:
      return newIcon;

    case IconType.NoApp:
      return noApp;

    case IconType.PanTool:
      return panTool;

    case IconType.PlusPlain:
      return plusPlain;

    case IconType.Print:
      return print;

    case IconType.Rotate90:
      return rotate90;

    case IconType.SecretarialApp:
      return secretarialApp;

    case IconType.Share:
      return share;

    case IconType.Star:
      return star;

    case IconType.StarBorder:
      return starBorder;

    case IconType.Success:
      return success;

    case IconType.TaxAmnestyApp:
      return taxAmnestyApp;

    case IconType.TaxApp:
      return taxApp;

    case IconType.TrialBalanceEstudioContableApp:
      return trialBalanceEstudioContableApp;

    case IconType.TrialBalanceApp:
      return trialBalanceApp;

    case IconType.UltraTaxApp:
      return ultraTaxApp;

    case IconType.User:
      return user;

    case IconType.Users:
      return users;

    case IconType.VatApp:
      return vatApp;

    case IconType.WorkpapersApp:
      return workpapersApp;

    default:
      throw new Error("bm-icon not found: ".concat((0, _stringify.default)(type)));
  }
}
